export default __webpack_public_path__ + "static/media/Logo_Empty.1e6339b3.svg";